import { ISearchOptionLandRegister } from '../../Interfaces/Helper/ISearchOptionLandRegister';
import { ICourtAdminstrativeUnitAssignment } from '../../Interfaces/ICourtAdminstrativeUnitAssignment';

/** Was BORIS zur Adresse liefert — jedes Feld kann fehlen. */
export interface IBorisPrefill {
  gemarkung?: string;
  flur?: string;
  flurstueck?: string;
}

const normalize = (value: string) => value.replace(/\s/g, '').toLowerCase();

/**
 * BORIS-Ergebnis in den aktuellen Stand der Suche einfügen.
 *
 * Bewusst als reine Funktion über `prev`: Die Abfrage läuft asynchron, während
 * der Dialog schon offen ist. Wird stattdessen der Stand von vor dem Request
 * zurückgeschrieben, verschwinden die Eingaben aus der Zwischenzeit — bei
 * offenem Dialog zuerst das Pflichtfeld Aktenzeichen, wodurch „Suchen" ohne
 * ersichtlichen Grund gesperrt bleibt.
 *
 * Angefasst wird nur, was BORIS wirklich liefert.
 */
export const applyBorisResult = (
  current: ISearchOptionLandRegister,
  boris: IBorisPrefill,
  adminUnits: ICourtAdminstrativeUnitAssignment[]
): ISearchOptionLandRegister => {
  const match = boris.gemarkung
    ? adminUnits.find(
        unit =>
          normalize(String(unit.AdministrativeUnit ?? '')) ===
          normalize(String(boris.gemarkung))
      )
    : undefined;

  return {
    ...current,
    idCourt: match ? match.idCourt : current.idCourt,
    idAdministrativeUnit: match
      ? match.idAdministrativeUnit
      : current.idAdministrativeUnit,
    Parcel: boris.flur || current.Parcel,
    LandParcel: boris.flurstueck || current.LandParcel,
  };
};
